import { TableFilterTypes } from '@ge/models/constants';

export const CaseDamagesColumns = {
  GROUP_SELECTED: 'group-selected',
  SELECTED: 'selected',

  GROUP_STATUS: 'group-status',
  STATUS: 'status',

  GROUP_CATEGORY: 'group-category',
  CATEGORY: 'category',

  GROUP_COMPONENT: 'group-component',
  COMPONENT: 'component',

  GROUP_LOCATION: 'group-location',
  LOCATION: 'location',

  GROUP_PART: 'group-part',
  PART: 'part',

  GROUP_DAMAGE: 'group-damage',
  DAMAGE: 'damage',

  GROUP_FOLLOW_UP_ACTION: 'group-follow-up-action',
  FOLLOW_UP_ACTION: 'followupAction',

  GROUP_CREATION_DATE: 'group-creation-date',
  CREATION_DATE: 'creationDate',

  GROUP_RUL_START_DATE: 'group-rul-start-date',
  RUL_START_DATE: 'rulStartDate',

  GROUP_INSPECTION_DATE: 'group-inspection-date',

  GROUP_FOLLOWUP_DATE: 'group-followup-date',
  FOLLOWUP_DATE: 'followupDate',

  GROUP_ACTION: 'group-action',
  ACTION: 'action',

  GROUP_DETAILS: 'group-details',
  DETAILS: 'details',
};

// Define all available columns in the case damages table.
export const CaseDamagesColumnDefs = {
  [CaseDamagesColumns.GROUP_SELECTED]: {
    cols: {
      [CaseDamagesColumns.SELECTED]: {
        minWidth: '50px',
        align: 'center',
        labels: [
          {
            a11yKey: 'table.selected',
            a11yDefault: '',
            sortValue: 'selected',
          },
        ],
      },
    },
  },
  [CaseDamagesColumns.GROUP_STATUS]: {
    cols: {
      [CaseDamagesColumns.STATUS]: {
        filterType: TableFilterTypes.CHECKBOXES,
        minWidth: '80px',
        align: 'center',
        labels: [
          {
            a11yKey: 'table.status',
            a11yDefault: 'STATUS',
            sortValue: 'status',
          },
        ],
      },
    },
  },
  [CaseDamagesColumns.GROUP_CATEGORY]: {
    cols: {
      [CaseDamagesColumns.CATEGORY]: {
        filterType: TableFilterTypes.CHECKBOXES,
        minWidth: '100px',
        align: 'center',
        labels: [
          {
            a11yKey: 'table.category',
            a11yDefault: 'CATEGORY',
            sortValue: 'category',
          },
        ],
      },
    },
  },
  [CaseDamagesColumns.GROUP_COMPONENT]: {
    cols: {
      [CaseDamagesColumns.COMPONENT]: {
        filterType: TableFilterTypes.CHECKBOXES,
        minWidth: '100px',
        align: 'left',
        labels: [
          {
            a11yKey: 'table.component',
            a11yDefault: 'COMPONENT',
            sortValue: 'component',
          },
        ],
      },
    },
  },
  [CaseDamagesColumns.GROUP_LOCATION]: {
    cols: {
      [CaseDamagesColumns.LOCATION]: {
        filterType: TableFilterTypes.CHECKBOXES,
        minWidth: '85px',
        align: 'left',
        labels: [
          {
            a11yKey: 'table.location',
            a11yDefault: 'LOCATION',
            sortValue: 'location',
          },
        ],
      },
    },
  },
  [CaseDamagesColumns.GROUP_PART]: {
    cols: {
      [CaseDamagesColumns.PART]: {
        filterType: TableFilterTypes.CHECKBOXES,
        minWidth: '70px',
        align: 'left',
        labels: [
          {
            a11yKey: 'table.part',
            a11yDefault: 'PART',
            sortValue: 'part',
          },
        ],
      },
    },
  },
  [CaseDamagesColumns.GROUP_DAMAGE]: {
    cols: {
      [CaseDamagesColumns.DAMAGE]: {
        filterType: TableFilterTypes.CHECKBOXES,
        minWidth: '115px',
        align: 'left',
        labels: [
          {
            a11yKey: 'table.damage',
            a11yDefault: 'DAMAGE',
            sortValue: 'damage',
          },
        ],
      },
    },
  },
  [CaseDamagesColumns.GROUP_FOLLOW_UP_ACTION]: {
    cols: {
      [CaseDamagesColumns.FOLLOW_UP_ACTION]: {
        filterType: TableFilterTypes.CHECKBOXES,
        minWidth: '150px',
        align: 'left',
        labels: [
          {
            a11yKey: 'table.follow_up_action',
            a11yDefault: 'FOLLOW UP ACTION',
            sortValue: 'followupAction',
          },
        ],
      },
    },
  },
  [CaseDamagesColumns.GROUP_CREATION_DATE]: {
    cols: {
      [CaseDamagesColumns.CREATION_DATE]: {
        filterType: TableFilterTypes.DATE,
        minWidth: '115px',
        align: 'center',
        labels: [
          {
            a11yKey: 'table.creation_date',
            a11yDefault: 'CREATION DATE',
            sortValue: 'creationDate',
          },
        ],
      },
    },
  },
  [CaseDamagesColumns.GROUP_RUL_START_DATE]: {
    cols: {
      [CaseDamagesColumns.RUL_START_DATE]: {
        filterType: TableFilterTypes.DATE,
        minWidth: '135px',
        align: 'center',
        labels: [
          {
            a11yKey: 'table.rul_start_date',
            a11yDefault: 'RUL START DATE',
            sortValue: 'rulStartDate',
          },
        ],
      },
    },
  },
  [CaseDamagesColumns.GROUP_FOLLOWUP_DATE]: {
    cols: {
      [CaseDamagesColumns.FOLLOWUP_DATE]: {
        filterType: TableFilterTypes.DATE,
        minWidth: '115px',
        align: 'center',
        labels: [
          {
            a11yKey: 'table.followup_date',
            a11yDefault: 'FOLLOWUP DATE',
            sortValue: 'followupDate',
          },
        ],
      },
    },
  },
  [CaseDamagesColumns.GROUP_ACTION]: {
    fixedRight: true,
    cols: {
      [CaseDamagesColumns.ACTION]: {
        fixedRight: true,
        minWidth: '50px',
        align: 'center',
        labels: [
          {
            a11yKey: 'table.action',
            a11yDefault: 'ACTION',
          },
        ],
        cell: {
          zeroPadding: true,
        },
      },
    },
  },
  [CaseDamagesColumns.GROUP_DETAILS]: {
    fixedRight: true,
    cols: {
      [CaseDamagesColumns.DETAILS]: {
        fixedRight: true,
        minWidth: '50px',
        align: 'center',
        labels: [
          {
            a11yKey: 'table.details',
            a11yDefault: 'DETAILS',
          },
        ],
        cell: {
          zeroPadding: true,
        },
      },
    },
  },
};

export const defaultCaseDamagesCols = [
  {
    id: CaseDamagesColumns.GROUP_SELECTED,
    cols: [
      {
        id: CaseDamagesColumns.SELECTED,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_STATUS,
    cols: [
      {
        id: CaseDamagesColumns.STATUS,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_CATEGORY,
    cols: [
      {
        id: CaseDamagesColumns.CATEGORY,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_COMPONENT,
    cols: [
      {
        id: CaseDamagesColumns.COMPONENT,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_LOCATION,
    cols: [
      {
        id: CaseDamagesColumns.LOCATION,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_PART,
    cols: [
      {
        id: CaseDamagesColumns.PART,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_DAMAGE,
    cols: [
      {
        id: CaseDamagesColumns.DAMAGE,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_FOLLOW_UP_ACTION,
    cols: [
      {
        id: CaseDamagesColumns.FOLLOW_UP_ACTION,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_CREATION_DATE,
    cols: [
      {
        id: CaseDamagesColumns.CREATION_DATE,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_RUL_START_DATE,
    cols: [
      {
        id: CaseDamagesColumns.RUL_START_DATE,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_FOLLOWUP_DATE,
    cols: [
      {
        id: CaseDamagesColumns.FOLLOWUP_DATE,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_ACTION,
    cols: [
      {
        id: CaseDamagesColumns.ACTION,
        visible: true,
      },
    ],
  },
  {
    id: CaseDamagesColumns.GROUP_DETAILS,
    cols: [
      {
        id: CaseDamagesColumns.DETAILS,
        visible: true,
      },
    ],
  },
];
